export default "__VITE_ASSET__iyXjUU3X__"